import { Component } from '@angular/core';

@Component({
  selector: 'app-form-company',
  template: `
    <p>
      form-company works!
    </p>
  `,
  styles: ``
})
export class FormCompanyComponent {

}
